<template>
    <div class="vue-location-search-input">
        <h1 class="mb-0">{{ translations.dealerNearby }}</h1>

        <div class="input-wrapper mt-2">
            <input
                type="search"
                class="form-input--search"
                v-model="value"
                @input="handleChange"
                :placeholder="inputPlaceholder"
                :disabled="disabled"
            >
            <aut-geo-locator
                @geo="handleGeo"
                @disabled="handleDisabled"
                @loading="handleLoading"
                @geo-error="handleGeoError"
                :using-input="usingInput"
            ></aut-geo-locator>

            <button
                type="submit"
                class="btn-primary form-submit"
                :value="translations.search">
            </button>

            <template v-if="loading">
                <div class="loading"></div>
            </template>
        </div>
    </div>
</template>

<script>
import translations from "../../mixins/translations";
import GeoLocator from "./GeoLocator";

export default {
    name: "GeoInput",

    mixins: [translations],

    components: {
        'aut-geo-locator': GeoLocator
    },

    data() {
        return {
            loading: false,
            geoLocation: {},
            value: '',
            usingCurrentLocation: false,
            disabled: false,
            usingInput: false,
        }
    },

    computed: {
        inputPlaceholder() {
            // if (this.usingCurrentLocation) {
            //     return this.translations.geoInputPlaceholderCurrentLocation;
            // }

            // return !this.loading ? this.translations.geoInputPlaceholder : this.translations.geoInputPlaceholderLoading;
            return this.translations.geoInputPlaceholder;
        },
    },

    mounted() {
        let urlParams = new URLSearchParams(window.location.search);
        this.value = urlParams.get('search');
        if (!_.isEmpty(this.value)) {
            this.handleChange();
        }
    },

    methods: {
        handleChange() {
            this.usingCurrentLocation = false;
            this.handleLoading(true);
            this.usingInput = true;
            this.geoCode();
        },

        geoCode: lodash.debounce(function () {
            this.$geocoder.send({
                address_line_1: this.value
            }, response => {
                if (response.status !== 'OK' || lodash.isEmpty(this.value)) {
                    this.loading = false;
                    this.$emit('reset');
                    return;
                }

                this.geoLocation = lodash.first(response.results).geometry.location;
                this.$emit('input', this.geoLocation);
                this.loading = false;
            });
        }, 500),

        handleGeo(payload) {
            this.value = '';
            this.usingCurrentLocation = true;
            this.$emit('geo', payload)
            this.handleLoading(false);
            this.disabled = false;
            this.usingInput = false;
        },

        handleDisabled(payload) {
            this.disabled = payload;
        },

        handleLoading(payload) {
            this.loading = payload;
            this.$emit('loading', payload)
        },

        handleGeoError() {
            this.usingCurrentLocation = false;
        }
    }
}
</script>
